import { TFunction } from 'i18next';
import { AdminInvoiceTotal } from 'models/admin-invoice';

export const INVOICE_TYPES = ['DEBIT', 'CREDIT'];
export const INVOICE_STATUSES = [
    'CREATED',
    'SCHEDULED',
    'PROCESSING',
    'SENT',
    'ERROR',
    'EXTERNAL_INVOICE_ERROR',
    'VOIDED',
];
export const INVOICE_PAYMENT_STATUSES = ['UNPAID', 'PAID'];

/** Label for an invoice enum value (type, status, payment status, delivery method); the raw value when unknown. */
export const invoiceLabel = (translate: TFunction, group: string, value?: string | null) =>
    value ? translate(`super-admin:INVOICE_${group}_${value}`, { defaultValue: value }) : '–';

/** "1 350,00 SEK" in the browser's locale. */
export const formatMoney = (amount?: number | null, currency?: string | null) => {
    if (amount === undefined || amount === null) return '–';
    const number = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return currency ? `${number} ${currency}` : number;
};

export const formatTotal = (total?: AdminInvoiceTotal | null) => formatMoney(total?.totalIncVat, total?.currency);
